// Choosing what sits in a dock slot: every app as a grid, the current one
// marked. Picking an app already in another slot swaps the two, so the bar
// never shows the same app twice. The fourth slot is always Apps.
import { Sheet } from '@/components/ui'
import { isPinnedNav } from '@/lib/useNav'
import { setDock, type PhoneLayout } from './layout'
import { savePhone, usePhoneApps } from './phone'
import { AppLabel, AppTile } from './AppIcon'

export const DockPicker = ({
  slot,
  layout,
  onClose,
}: {
  slot: number | null
  layout: PhoneLayout
  onClose: () => void
}) => {
  const { apps } = usePhoneApps()
  if (slot === null) return null
  const current = layout.dock[slot]
  // pinned pages and lists can sit in the dock too; they come last
  const choices = [...apps.filter((a) => !isPinnedNav(a.key)), ...apps.filter((a) => isPinnedNav(a.key))]
  return (
    <Sheet open onClose={onClose} title={`Dock slot ${slot + 1}`}>
      <div className="grid grid-cols-5 gap-x-1.5 gap-y-4" data-testid="dock-picker">
        {choices.map((a) => (
          <button
            key={a.key}
            type="button"
            onClick={() => {
              void savePhone(setDock(layout, slot, a.key))
              onClose()
            }}
            className="flex flex-col items-center gap-1.5 min-w-0"
            aria-pressed={a.key === current}
            data-testid={`dock-pick-${a.key}`}
          >
            <AppTile app={a} tint={layout.icons} active={a.key === current} />
            <AppLabel active={a.key === current}>{a.label}</AppLabel>
          </button>
        ))}
      </div>
    </Sheet>
  )
}
